// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"0915d4f6","787":"d8bfe95b"}[chunkId] + ".chunk.js";
};